// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nationality-avatar[data-v-2a36817a]{position:relative;margin:0}.nationality-avatar>div[data-v-2a36817a]{border-radius:50%;overflow:hidden}.nationality-avatar>div[data-v-2a36817a]:first-of-type{box-shadow:0 0 2px rgba(0,0,0,.1607843137)}.nationality-avatar>div[data-v-2a36817a]:last-of-type:not(:first-of-type){position:absolute;right:5%;bottom:5%;width:20%}", ""]);
// Exports
module.exports = exports;
